'use client';

import { __makeTemplateObject } from '../_virtual/_tslib.js';
import styled from 'styled-components';
import { colors } from '../Utils/constants.js';
import TrustedIcon from './trusted-icon.js';

var sizes = {
    xs: 12,
    sm: 14,
    md: 15
};
var Container = styled.p(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    width: fit-content;\n    ", "\n    font-weight: 500;\n    font-size: ", "px;\n    margin-top: 0;\n    display: -webkit-box;\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    word-break: break-all;\n"], ["\n    position: relative;\n    width: fit-content;\n    ", "\n    font-weight: 500;\n    font-size: ", "px;\n    margin-top: 0;\n    display: -webkit-box;\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    word-break: break-all;\n"])), function (_a) {
    var isTrusted = _a.isTrusted, paddingRight = _a.paddingRight;
    return isTrusted
        ? "\n        padding-right: ".concat(paddingRight, "px;\n    ")
        : '';
}, function (_a) {
    var size = _a.size, fontSize = _a.fontSize;
    return (fontSize !== 0 ? fontSize : sizes[size]);
});
var Link = styled.a(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    color: ", ";\n    &:hover {\n        color: ", ";\n    }\n"], ["\n    color: ", ";\n    &:hover {\n        color: ", ";\n    }\n"])), function (_a) {
    var color = _a.color;
    return color;
}, colors.buttonColor);
var Name = styled.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    cursor: default;\n    color: ", ";\n"], ["\n    cursor: default;\n    color: ", ";\n"])), function (_a) {
    var color = _a.color;
    return color;
});
styled(TrustedIcon)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    position: absolute;\n    top: 50%;\n    right: 0;\n    transform: translateY(-50%);\n"], ["\n    position: absolute;\n    top: 50%;\n    right: 0;\n    transform: translateY(-50%);\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;

export { Container, Link, Name };
//# sourceMappingURL=TrustedCompanyName.css.js.map
